import { css } from '@emotion/core';

export const cssResultContainer = css`
  background-color: #fff;
  min-height: 300px;
`;
